module.exports = __webpack_public_path__ + "2756e1ea19fb77aa3577b5bd01cc86ee.svg";